import { useNavigate } from 'react-router-dom';
import { Typography, Icons, Icon, ButtonGroup, TextButton } from '../../../shared';
import { AppRoutes } from '../../../../constants';
import { ComponentSize } from '../../../../types';

interface ProcessingFailureStateProps {
  onTryAgain: () => void;
}

const ProcessingFailureState = ({ onTryAgain }: ProcessingFailureStateProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex h-32 flex-col items-center justify-center gap-6">
      <Icons icon={Icon.TRIANGLE_ALERT} size={ComponentSize.LARGE} />
      <Typography>Creation process failed. Please try again.</Typography>
      <ButtonGroup className="w-full justify-start">
        <TextButton onClick={onTryAgain} text="Try again" />
        <TextButton onClick={() => navigate(AppRoutes.SIMULATIONS)} text="Cancel" />
      </ButtonGroup>
    </div>
  );
};

export default ProcessingFailureState;
